import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=183c5db8&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=183c5db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c5db8",
  null
  
)

export default component.exports